var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Maalesef böyle bir sayfamız yok :(")]),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/"}},[_vm._v("Ana Sayfa")]),_c('span',[_vm._v("'ya dönmeyi deneyebilirsin.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }